define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.writtenFnumbers = exports.writtenNumbers = exports.defaultRegionCode = exports.defaultCountryCode = exports.xAxisTimeseries = exports.defaultToastMs = exports.IndicatorsOverViewColorPattern = exports.DEFAULT_TAKE = exports.LoadingData = exports.NotData = exports.DefaultError = void 0;
    exports.DefaultError = 'Ocorreu um erro inesperado, por favor entre em contato com o suporte';
    exports.NotData = 'Não existem dados cadastrados';
    exports.LoadingData = 'Carregando dados, por favor aguarde';
    exports.DEFAULT_TAKE = 50;
    exports.IndicatorsOverViewColorPattern = ['#411E5A', '#FF9201', '#3D7981', '#D23C28', '#6E4B87', '#BDBDBD'];
    exports.defaultToastMs = 5000;
    exports.xAxisTimeseries = 'timeseries';
    exports.defaultCountryCode = 'BRA';
    exports.defaultRegionCode = 'SP';
    exports.writtenNumbers = {
        2: 'Dois',
        3: 'Três',
        4: 'Quatro',
        5: 'Cinco',
        6: 'Seis',
        7: 'Sete',
        8: 'Oito',
        9: 'Nove',
        10: 'Dez',
        11: 'Onze',
        12: 'Doze',
        13: 'Treze',
        14: 'Quatorze',
        15: 'Quinze',
        16: 'Dezesseis',
        17: 'Dezessete',
        18: 'Dezoito',
        19: 'Dezenove',
        20: 'Vinte',
    };
    exports.writtenFnumbers = {
        2: 'Duas',
        3: 'Três',
        4: 'Quatro',
        5: 'Cinco',
        6: 'Seis',
        7: 'Sete',
        8: 'Oito',
        9: 'Nove',
        10: 'Dez',
        11: 'Onze',
        12: 'Doze',
        13: 'Treze',
        14: 'Quatorze',
        15: 'Quinze',
        16: 'Dezesseis',
        17: 'Dezessete',
        18: 'Dezoito',
        19: 'Dezenove',
        20: 'Vinte',
    };
});
